import { getEncodedUrl } from "@catchoftheday/utilities";
import {
  URL_ONEPASS_CONSENT,
  URL_ONEPASS_OAUTH_REDIRECT,
  URL_ONEPASS_SUBSCRIBE,
} from "../consts";

export const generateOnePassLinkingUrl = (
  url: string,
  queryParams?: { [key: string]: string }
) =>
  `${URL_ONEPASS_OAUTH_REDIRECT}?n=1&_destination=${encodeURIComponent(
    getEncodedUrl(url, {
      showmessage: "l",
      ...queryParams,
    })
  )}`;

type GenerateOnePassUpsellUrlParams = {
  url: string;
  cta: "start-free-trial" | "join";
};

export const generateOnePassUpsellUrl = ({
  url = "/",
  cta = "start-free-trial",
}: GenerateOnePassUpsellUrlParams) =>
  `${URL_ONEPASS_SUBSCRIBE}?_destination=${getEncodedUrl(url, {
    showmessage: "u",
  })}&utm_cta=${cta}`;

export const generateOnePassConsentUrl = (
  url: string,
  queryParams?: { [key: string]: string }
) => {
  const destinationUrl =
    queryParams && Object.keys(queryParams).length > 0
      ? getEncodedUrl(url, { ...queryParams })
      : url;
  return `${URL_ONEPASS_CONSENT}?_destination=${encodeURIComponent(
    destinationUrl
  )}`;
};
